function sortObjectByKey(array, key) {
  return array.sort(function (a, b) {
    var x = a[key];
    var y = b[key];
    return x < y ? -1 : x > y ? 1 : 0;
  });
}

export function findTransform(transforms, predicate) {
  var transformCandidates = [];
  for (let i = 0; i < transforms.length; i++) {
    const candidate = transforms[i];
    if (predicate(candidate)) {
      transformCandidates.push(transforms[i]);
    }
  }

  // Sort the matched paragraphs by priority of transoforms
  transformCandidates = sortObjectByKey(transformCandidates, "priority");

  return transformCandidates && transformCandidates.length > 0
    ? transformCandidates[0]
    : undefined;
}
